export const activityFilterList = [
  'absence_created',
  'absence_updated',
  'appointment_created',
  'appointment_label_changed',
  'appointment_moved',
  'appointment_removed',
  'appointment_updated',
  'appointment_report_created',
  'appointment_report_updated',
  'appointment_report_removed',
  'customer_created',
  'customer_updated',
  'customer_merged',
  'customer_deleted',
  'discount_code_created',
  'discount_code_updated',
  'discount_code_deleted',
  'export_appointments',
  'export_absences',
  'export_customers',
  'export_current_stock',
  'export_datev',
  'export_day_totals',
  'export_deleted_appointments',
  'export_drawer_transactions',
  'export_gobd',
  'export_orders',
  'export_order_items',
  'export_products',
  'export_treatment_reports',
  'export_worked_hours',
  'form_submission_created',
  'form_submission_updated',
  'form_submission_removed',
  'ipl_treatment_created',
  'ipl_treatment_updated',
  'ipl_treatment_removed',
  'ipl_treatment_report_created',
  'ipl_treatment_report_updated',
  'ipl_treatment_report_removed',
  'note_created',
  'note_updated',
  'note_removed',
  'order_removed',
  'user_updated',
  'waiting_list_entry_deleted',
  'waiting_list_entry_created',
];
